import styles from './styles';

import React from 'react';

import type { WithStyles } from '@material-ui/core';

import ReadOnly from '../../../../clinical/read-only';
import CalculatedLabel from '../../../calculated-label';

import { withStyles } from '@material-ui/core';

export interface IProps extends WithStyles<typeof styles> {
  height: number;
  weight: number;
}

class BMIFieldReadonly extends React.Component<IProps> {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { classes, height, weight } = this.props;
    return (
      <div className={classes.root}>
        <span>
          Height: <ReadOnly value={height} /> cm.
        </span>{' '}
        <span>
          Weight: <ReadOnly value={weight} /> kg.
        </span>{' '}
        <span>
          BMI: <CalculatedLabel func="bmi" height={height} weight={weight} />
        </span>
      </div>
    );
  }
}
export default withStyles(styles)(BMIFieldReadonly);
